var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { flip, shift, offset, arrow, computePosition, autoUpdate } from '@floating-ui/dom';
var Popover = /** @class */ (function () {
    function Popover(dotNetRef) {
        this._dotNetRef = dotNetRef;
    }
    Popover.prototype.setPopover = function (settings) {
        var _this = this;
        var trigger = this.getTrigger(settings);
        if (trigger) {
            if (settings.triggerEvents) {
                settings.triggerEvents.forEach(function (triggerEvent) {
                    trigger.addEventListener(triggerEvent, function () {
                        var surface = _this.getSurface(settings);
                        if (surface) {
                            _this.showSurface(settings);
                        }
                        else {
                            _this.renderSurface(settings);
                        }
                    });
                });
            }
            if (settings.hideEvents) {
                settings.hideEvents.forEach(function (hideEvent) {
                    trigger.addEventListener(hideEvent, function () {
                        _this.hideSurface(settings);
                    });
                });
            }
        }
    };
    Popover.prototype.showSurface = function (settings) {
        return __awaiter(this, void 0, void 0, function () {
            var surface, trigger_1, trigger;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        surface = this.getSurface(settings);
                        if (!!surface) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.renderSurface(settings)];
                    case 1:
                        _a.sent();
                        surface = this.getSurface(settings);
                        _a.label = 2;
                    case 2:
                        if (settings.sameWidth) {
                            trigger_1 = this.getTrigger(settings);
                            if (!this._triggerResizeObserver) {
                                this._triggerResizeObserver = new ResizeObserver(function () {
                                    _this.setSurfaceWidth(trigger_1, surface);
                                });
                                this._triggerResizeObserver.observe(trigger_1);
                            }
                            this.setSurfaceWidth(trigger_1, surface);
                        }
                        surface.classList.remove('hidden');
                        this.updatePosition(settings);
                        if (!surface.classList.contains('show'))
                            surface.classList.add('show');
                        document.addEventListener('click', this.onDocumentClicked.bind(this, settings), { once: true });
                        trigger = this.getTrigger(settings);
                        if (trigger && surface) {
                            // Ensure previous auto-update (if any) is cleared before adding a new one
                            if (this._cleanupAutoUpdate) {
                                this._cleanupAutoUpdate();
                            }
                            this._cleanupAutoUpdate = autoUpdate(trigger, surface, function () { return _this.updatePosition(settings); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Popover.prototype.updatePosition = function (settings) {
        var surface = this.getSurface(settings);
        var trigger = this.getTrigger(settings);
        var arrowElement = this.getArrow(settings);
        if (!surface || !trigger)
            return;
        computePosition(trigger, surface, {
            placement: settings.placement,
            middleware: [
                flip(),
                shift({ padding: settings.padding }),
                offset(settings.offset),
                arrow({ element: arrowElement }),
            ],
        }).then(function (_a) {
            var _b;
            var x = _a.x, y = _a.y, placement = _a.placement, middlewareData = _a.middlewareData;
            Object.assign(surface.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
            });
            // Accessing the data
            var _c = middlewareData.arrow, arrowX = _c.x, arrowY = _c.y;
            var staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[placement.split('-')[0]];
            if (arrowElement) {
                Object.assign(arrowElement.style, (_b = {
                        left: arrowX != null ? "".concat(arrowX, "px") : '',
                        top: arrowY != null ? "".concat(arrowY, "px") : '',
                        right: '',
                        bottom: ''
                    },
                    _b[staticSide] = '-4px',
                    _b));
            }
        });
    };
    Popover.prototype.renderSurface = function (settings) {
        return __awaiter(this, void 0, void 0, function () {
            var surface;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._dotNetRef.invokeMethodAsync('RenderSurface', settings)];
                    case 1:
                        _a.sent();
                        surface = this.getSurface(settings);
                        if (surface) {
                            this._surfaceResizeObserver = new ResizeObserver(function () { _this.updatePosition(settings); });
                            this._surfaceResizeObserver.observe(surface);
                            new MutationObserver(function (mutationList, observer) {
                                mutationList.forEach(function (item) {
                                    item.removedNodes.forEach(function (removedNode) {
                                        if (removedNode == surface) {
                                            // window.removeEventListener('scroll', this._scrollEventHandler);
                                            _this._surfaceResizeObserver.disconnect();
                                            observer.disconnect();
                                        }
                                    });
                                });
                            }).observe(surface.parentElement, { childList: true });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Popover.prototype.onDocumentClicked = function (settings, args) {
        var trigger = this.getTrigger(settings);
        var surface = this.getSurface(settings);
        if (trigger && surface) {
            if (trigger.contains(args.target) || surface.contains(args.target) || args.defaultPrevented) {
                document.addEventListener('click', this.onDocumentClicked.bind(this, settings), { once: true });
            }
            else {
                this.hideSurface(settings);
            }
        }
    };
    // private onDocumentScroll(settings: PopoverSettings) {
    //     this.updatePosition(settings);
    // }
    Popover.prototype.hideSurface = function (settings) {
        var _this = this;
        var surface = this.getSurface(settings);
        if (surface) {
            surface.addEventListener("transitionend", function (event) {
                _this.doHideSurface(settings, surface);
            }, { once: true });
            if (surface.classList.contains('show'))
                surface.classList.remove('show');
            else
                this.doHideSurface(settings, surface);
        }
        else {
            this.doHideSurface(settings, surface);
        }
    };
    Popover.prototype.doHideSurface = function (settings, surface) {
        surface === null || surface === void 0 ? void 0 : surface.classList.add('hidden');
        this._dotNetRef.invokeMethodAsync('HideSurface', settings);
        if (this._triggerResizeObserver) {
            this._triggerResizeObserver.disconnect();
            this._triggerResizeObserver = null;
        }
        // De-register auto update/scroll listeners when surface is hidden
        if (this._cleanupAutoUpdate) {
            this._cleanupAutoUpdate();
            this._cleanupAutoUpdate = null;
        }
    };
    Popover.prototype.getTrigger = function (settings) {
        return document.querySelector("#".concat(settings.triggerId));
    };
    Popover.prototype.getSurface = function (settings) {
        return document.querySelector(this.getSurafeSelector(settings));
    };
    Popover.prototype.getArrow = function (settings) {
        return document.querySelector("".concat(this.getSurafeSelector(settings), ">.arrow"));
    };
    Popover.prototype.getSurafeSelector = function (settings) {
        return "#".concat(settings.triggerId, "_surface");
    };
    Popover.prototype.setSurfaceWidth = function (trigger, surface) {
        if (trigger && surface) {
            surface.style.width = "".concat(trigger.getBoundingClientRect().width, "px");
        }
    };
    Popover.create = function (dotNetRef) {
        return new Popover(dotNetRef);
    };
    return Popover;
}());
export { Popover };
